// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'
import { i18n } from '../../domain/index'
import css from './confirmModal.css'
type Props = {
  open: boolean
  title: string
  content?: any
  okButtonText?: string
  okButtonClass?: string
  cancelButtonText?: string
  cancelButtonClass?: string
  onClose: (...args: Array<any>) => any
}

type ConfirmReason = 'confirmClick' | 'cancelClick' | 'backdropClick'

class ConfirmModal extends React.Component<Props> {
  handleClose = (confirm: boolean, reason: ConfirmReason) => {
    if (reason === 'backdropClick') {
      this.props.onClose(false)
    } else {
      this.props.onClose(confirm)
    }
  }

  render() {
    const { open, title, content, okButtonText, okButtonClass, cancelButtonText, cancelButtonClass } = this.props
    return (
      <div className={css.component}>
        <Dialog
          open={open}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby='alert-dialog-slide-title'
          aria-describedby='alert-dialog-slide-description'
        >
          <DialogTitle id='alert-dialog-slide-title'>{title}</DialogTitle>
          {!!content && (
            <DialogContent>
              <DialogContentText id='alert-dialog-slide-description'>{content}</DialogContentText>
            </DialogContent>
          )}
          <DialogActions className={css.alertDialogSlideActions}>
            <Button
              onClick={() => this.handleClose(false)}
              className={css[cancelButtonClass] ? css[cancelButtonClass] : ''}
            >
              {cancelButtonText ? cancelButtonText : i18n.t('confirmModal.cancelButtonText')}
            </Button>
            <Button
              onClick={() => this.handleClose(true)}
              color='primary'
              variant='contained'
              className={css[okButtonClass] ? css[okButtonClass] : ''}
            >
              {okButtonText ? okButtonText : i18n.t('confirmModal.okButtonText')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default ConfirmModal
